import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import PoweredByLogo from "assets/images/logo-large.png";

// Helper to build absolute URLs for assets returned as relative paths
const buildAssetSrc = (url) => {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  const apiBase = process.env.REACT_APP_API || "https://dev.beclutch.club/api/";
  const assetBase = apiBase.replace(/\/api\/?$/, "/");
  const cleanPath = url.startsWith("/") ? url.slice(1) : url;
  return assetBase + cleanPath;
};

const MainNav = (props) => {
  const { resStatus, appInfo } = props;

  const [activeClass, setActiveClass] = useState("");
  const [activeBtnClass, setActiveBtnClass] = useState("");

  // add class when scrolldown
  useEffect(() => {
    const handleScrollEvent = () => {
      const top = window.pageYOffset || document.documentElement.scrollTop;
      if (top > 50) {
        setActiveClass(`nav-active`);
        setActiveBtnClass(`btn-active`);
        return;
      }
      setActiveClass("");
      setActiveBtnClass("");
    };

    window.addEventListener("scroll", handleScrollEvent);

    return () => window.removeEventListener("scroll", handleScrollEvent);
  }, []);


  const site = appInfo?.site_config || {};
  const isSingleHomepage = site.homepage_type === "single";
  const rightLogo = buildAssetSrc(site.logo_right);

  const navWrapperRef = useRef(null);
  const titleRef = useRef(null);
  const leftLogoRef = useRef(null);
  const rightLogoRef = useRef(null);

  const updateSizes = useCallback(() => {
    if (!navWrapperRef.current) return;
    const titleWidth = titleRef.current ? titleRef.current.offsetWidth : 0;
    const leftWidth = leftLogoRef.current ? leftLogoRef.current.offsetWidth : 0;
    const rightWidth = rightLogoRef.current ? rightLogoRef.current.offsetWidth : 0;
    navWrapperRef.current.style.setProperty("--title-width", `${titleWidth}px`);
    navWrapperRef.current.style.setProperty("--left-logo-width", `${leftWidth}px`);
    navWrapperRef.current.style.setProperty("--right-logo-width", `${rightWidth}px`);
  }, []);

  useLayoutEffect(() => {
    updateSizes();
    window.addEventListener("resize", updateSizes);
    return () => window.removeEventListener("resize", updateSizes);
  }, [updateSizes, site.site_title, site.site_subtitle, isSingleHomepage, rightLogo]);

  return (
    <div className={`nav ${activeClass}`}>
      <div className="nav-content-wrapper" ref={navWrapperRef}>
        {/* Left Slot */}
        <div className="nav-logo-left">
          {isSingleHomepage ? (
            <img ref={leftLogoRef} src={PoweredByLogo} alt="Powered by BeClutch" className="club-logo-left nav-powered-by-logo" onLoad={updateSizes} />
          ) : (
            buildAssetSrc(site.logo_left) && (
              site.logo_left_url ? (
                <a href={site.logo_left_url} target="_self" rel="noopener noreferrer">
                  <img ref={leftLogoRef} src={buildAssetSrc(site.logo_left)} alt={site.site_title || "Logo"} className="club-logo-left" onLoad={updateSizes} />
                </a>
              ) : (
                <img ref={leftLogoRef} src={buildAssetSrc(site.logo_left)} alt={site.site_title || "Logo"} className="club-logo-left" onLoad={updateSizes} />
              )
            )
          )}
        </div>

        {/* Center Title */}
        <Link to="/" className="nav-title-link" ref={titleRef}>
          {(site.site_title || site.site_subtitle) && (
            <div className="club-title">
              {site.site_title && <div className="club-title-name">{site.site_title}</div>}
              {!isSingleHomepage && site.site_subtitle && <div className="club-title-sub">{site.site_subtitle}</div>}
            </div>
          )}
        </Link>

        {/* Right Slot */}
        <div className="nav-logo-right">
          {rightLogo && (
            site.logo_right_url ? (
              <a href={site.logo_right_url} target="_self" rel="noopener noreferrer">
                <img ref={rightLogoRef} src={rightLogo} alt="logo-right" className="club-logo-right" onLoad={updateSizes} />
              </a>
            ) : (
              <img ref={rightLogoRef} src={rightLogo} alt="logo-right" className="club-logo-right" onLoad={updateSizes} />
            )
          )}
        </div>
      </div>

      {isSingleHomepage && site.site_subtitle && (
        <div className="nav-subtitle-banner">{site.site_subtitle}</div>
      )}
    </div>
  );
};

export default MainNav;
